module.exports = __webpack_public_path__ + "img/ok.7c44b575.svg";